import { render, staticRenderFns } from "./CompaniesOrders.vue?vue&type=template&id=3d4fc778&scoped=true&"
import script from "./CompaniesOrders.vue?vue&type=script&lang=js&"
export * from "./CompaniesOrders.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesOrders.vue?vue&type=style&index=0&id=3d4fc778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4fc778",
  null
  
)

export default component.exports